<ng-container>

  <div>
    <b>{{ name }}</b>
    <app-info class="formGroupLabel" [wide]="false" [placement]="'left'">
      <div class="tooltipContent">
        <b>Considering</b>
        <ul>
          @for (consider of splitConsidering(); track consider) {
            <div>
              <li>
                {{ consider }}
              </li>
            </div>
          }
        </ul>
      </div>
    </app-info>
  </div>

  <ng-container>
    <div class="row">
      <div class="col-md fieldset">
        <app-visit-exemptions-exemption-common [exemption]="exemption"></app-visit-exemptions-exemption-common>
      </div>
      <div class="col-md fieldset">
        <div class="row">
          <app-form-group label="Substance">
            <app-search [(ngModel)]="dangerousGoods" dataKey="name"
                        (ngModelChange)="onDangerousGoodsChange(dangerousGoods)"
                        [inputFormatter]="portVisitUtils.dangerousGoodsFormatter"
                        [searchFunction]="portVisitUtils.findDangerousGoods"
                        [resultFormatter]="portVisitUtils.dangerousGoodsFormatter"
                        placeholder="Find by name or UN code">
            </app-search>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Substance name</label>
              <div class="tooltipContent">If unknown select 0000</div>
            </app-info>
            <textarea [(ngModel)]="exemption.substanceName" id="substanceName" type="text" rows="3" maxlength="1024"
                      class="form-control" required></textarea>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>UN number</label>
              <div class="tooltipContent">If unknown select 0000</div>
            </app-info>
            <input [(ngModel)]="exemption.unVnNumber" id="unVnNumber" type="text" maxlength="256"
                   class="form-control" required>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Reason for request for exemption</label>
              <div class="tooltipContent">A minimum of 20 characters is required</div>
            </app-info>
            <textarea [(ngModel)]="exemption.reason" id="reason" type="text" rows="3" minlength="20" maxlength="1024"
                      class="form-control" required></textarea>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Details">
            <textarea [(ngModel)]="exemption.details" id="details" type="text" rows="3" maxlength="256"
                      class="form-control"></textarea>
          </app-form-group>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
